var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckbxoUnchecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4141 0.5625C17.0234 0.1875 16.5469 0 15.9844 0H2.01562L1.7981 0.00878906C1.30249 0.0498047 0.890625 0.234375 0.5625 0.5625C0.1875 0.9375 0 1.42188 0 2.01562V15.9844L0.00915527 16.1913C0.0518799 16.6647 0.244141 17.0723 0.585938 17.4141C0.976562 17.8047 1.45312 18 2.01562 18H15.9844L16.1913 17.9908C16.6647 17.9481 17.0723 17.7559 17.4141 17.4141C17.8047 17.0234 18 16.5469 18 15.9844V2.01562L17.9908 1.7981C17.9481 1.30249 17.7559 0.890625 17.4141 0.5625ZM2.73197 2H15.268L15.3979 2.00767C15.5611 2.0283 15.687 2.09123 15.8053 2.20477C15.9386 2.33271 16 2.4851 16 2.73197V15.268L15.9923 15.3928C15.9715 15.5498 15.9076 15.6715 15.7896 15.7896C15.642 15.9372 15.4887 16 15.268 16H2.73197L2.60718 15.9923C2.45023 15.9715 2.32847 15.9076 2.21042 15.7896C2.06286 15.642 2 15.4887 2 15.268V2.73197L2.00515 2.61186C2.02236 2.42409 2.08286 2.29591 2.18939 2.18939C2.31722 2.06156 2.47623 2 2.73197 2Z",
    fill: "#7956D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbxoUnchecked);
export default __webpack_public_path__ + "static/media/checkbxo-unchecked.86f285e3effbc710f7b8c1114b8b0675.svg";
export { ForwardRef as ReactComponent };